import { useEffect, useRef, type ChangeEvent } from 'react';

import { ReactComponent as CloseIcon } from '../../../../assets/icons/close.svg';
import { ReactComponent as SearchIcon } from '../../../../assets/icons/search.svg';
import type { ISearchBarProps } from '../../../interfaces/globals';
import Spinner from '../Spinner/Spinner';
import './SearchBar.scss';

const SearchBar = ({
  value,
  onChange,
  placeholder,
  isLoading = false,
  disabled = false,
  onClear,
  autoFocus = false,
  className
}: ISearchBarProps) => {
  const inputRef = useRef<HTMLInputElement | null>(null);
  const hasValue = value.trim().length > 0;
  const showClear = hasValue && !isLoading;
  const rootClass = ['search-bar', className].filter(Boolean).join(' ');

  const handleChange = (event: ChangeEvent<HTMLInputElement>) => {
    onChange(event.target.value);
  };

  const handleClear = () => {
    if (onClear) onClear();
    else onChange('');
  };

  useEffect(() => {
    if (autoFocus) inputRef.current?.focus();
  }, [autoFocus]);

  return (
    <div className={rootClass}>
      <SearchIcon className="search-bar__icon" aria-hidden width={15} height={15} />
      <input
        ref={inputRef}
        type="text"
        className="search-bar__input"
        placeholder={placeholder}
        value={value}
        onChange={handleChange}
        disabled={disabled}
      />
      {isLoading && <Spinner variant="ring" size={14} className="search-bar__spinner" />}
      {showClear && (
        <button type="button" className="search-bar__clear" onClick={handleClear} aria-label="Clear search">
          <CloseIcon width={16} height={16} aria-hidden="true" />
        </button>
      )}
    </div>
  );
};

export default SearchBar;
